import api from "../../../services/api"

export default {
  getUser: (context, value) => {
    api.get_user_info().then((response) => {
      context.commit("getUser", response)
    })
  },
}
